import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { DOCTOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import './InvoicePrint.css';

interface Invoice {
    logo: string;
    hospitalname: string;
    address: string;
}

export const InvoicePrint = () => {
    const uid = window.sessionStorage.getItem('uid');
    const usertype = window.sessionStorage.getItem('usertype');

    const [globalFilter, setGlobalFilter] = useState('');
    const location = useLocation();
    const dispatch = useDispatch();
    const tax = 0;
    const today = new Date();
    const { id } = useParams();
    const [invoiceData, setInvoiceData] = useState<Invoice[]>([]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.get("id");
    }, [location]);

    const getInvoiceData = async () => {
        try {
            const payload = { q: 4, userid: uid, invoice_id: id };
            // const apiname = DOCTOR_API.invoice_API;

            const apiname =usertype === 'doctor' ? DOCTOR_API.invoice_API:"/ws_an_patient_reports.php"

            const response = await LoginService.getData(apiname, payload);
            setInvoiceData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (id) getInvoiceData();
    }, [id]);

    const logo = invoiceData[0]?.logo;
    const hospitalname = invoiceData[0]?.hospitalname;
    const Address = invoiceData[0]?.address;

    return (
        <div className="content-wrapper" style={{ marginLeft: "200px" }}>
            <section className="content-header">
                <h1>Invoice <small>#{id}</small></h1>
            </section>

            <Panel style={{ width: 'auto', height: 'auto' }}>
                <div>
                    <h2><i className='pi pi-info'></i> Note</h2>
                    <h3>This page has been enhanced for printing. Click the print button at the bottom of the invoice to test.</h3>
                </div>
            </Panel>

            <section className="invoice" style={{ marginTop: '-50px' }}>
                {invoiceData.map((item: any, index: number) => (
                    <Card key={index} className="p-mb-4">

                        {/* Header */}
                        <div className="p-grid align-items-center">
                            <div className="p-col-12">
                                <h2 className="page-header text-left p-3">
                                    <i className="pi pi-globe"></i> e Medicall, Inc.
                                </h2>

                                <b
                                    className="pull-right"
                                    style={{
                                        display: 'block',
                                        textAlign: 'right',
                                        fontWeight: 500
                                    }}
                                >
                                    Date: {today.toLocaleDateString('en-US', {
                                        weekday: 'long',
                                        month: 'long',
                                        day: 'numeric',
                                        year: 'numeric'
                                    })}
                                </b>

                                <h3 className="page-header text-left p-3">
                                    <img
                                        src={logo}
                                        alt="Hospital Logo"
                                        style={{
                                            width: '60px',
                                            height: '46px',
                                            borderRadius: '50%',
                                            verticalAlign: 'middle',
                                            marginRight: '8px'
                                        }}
                                    />
                                    | {hospitalname} | Address : {Address}
                                </h3>
                            </div>
                        </div>

                        {/* Patient / Doctor / Invoice Info */}
                        <div className="grid p-3">
                            <div className="col-12 md:col-4 text-left">
                                <h4 style={{ fontWeight: 400 }}>Patient</h4>
                                <address>
                                    <strong>{item.pfname} | {item.plname}</strong><br />
                                    Door-No: {item.dno} | Street: {item.pstreet}<br />
                                    {item.pcity} | {item.State} | {item.CountryName}.<br />
                                    Phone: {item.pmob}<br />
                                    Email: {item.pemail}
                                </address>
                            </div>

                            <div className="col-12 md:col-4 text-left">
                                <h4 style={{ fontWeight: 400 }}>Doctor</h4>
                                <address>
                                    <strong>{item.FirstName} | {item.LastName}</strong><br />
                                    {item.D_No} | {item.Street} | {item.City}<br />
                                    {item.CountryName}, {item.Zip}<br />
                                    Phone: {item.Mobile}<br />
                                    Email: {item.Email}
                                </address>
                            </div>

                            <div className="col-12 md:col-4 text-left" style={{ marginTop: '60px' }}>
                                <b>Invoice #{id}</b><br />
                                <b>Case ID:</b> {item.CaseID}<br />
                                <b>Payment Date:</b> {item.PaidDate}<br />
                                <b>Amount:</b> {item.Amount}
                            </div>
                        </div>


                        {/* Table */}
                        <div className="p-grid">
                            <div className="p-col-12">
                                <DataTable value={invoiceData} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter}>
                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No" />
                                    <Column header="Transaction ID" body={() => id} />
                                    <Column field="Sickness" header="Sickness" />
                                    <Column field="Createdate" header="Created Date" />
                                    <Column field="Amount" header="Amount" />
                                </DataTable>
                            </div>
                        </div>

                        {/* Totals */}
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6"></div>
                            <div className="p-col-12 p-md-6 text-right">
                                <p className="lead">Amount paid on {item.PaidDate}</p>
                                <table style={{ float: 'right', marginRight: '50px' }}>
                                    <tbody>
                                        <tr>
                                            <th style={{ width: '150px' }}>Subtotal:</th>
                                            <td>{item.Amount}/-</td>
                                        </tr>
                                        <tr>
                                            <th style={{ width: '150px' }}>Total:</th>
                                            <td>{item.Amount + tax}/-</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Print Button */}
                        <div className="p-grid justify-content-center mt-4">
                            <Button
                                label="Print"
                                icon="pi pi-print"
                                onClick={() => window.print()}
                                className="p-button-secondary"
                            />
                        </div>

                    </Card>
                ))}
            </section>
        </div>
    );
};
